import { AppPagePlaceholder } from "./AppPagePlaceholder";

export function MailPage() {
  return <AppPagePlaceholder name="Mail" />;
}
